module.exports = __webpack_public_path__ + "static/media/editorial.98acfccd.svg";